exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--primary[data-v-5ee46b4d]{background:#2675f1;border-color:#2675f1}.num[data-v-5ee46b4d]{font-size:.28rem;font-family:Roboto-Regular,Roboto;font-weight:400;color:#1f1f1f}.con p[data-v-5ee46b4d]:first-child{font-size:.24rem;font-family:Roboto-Medium,Roboto;font-weight:500;color:#1f1f1f;line-height:.28rem}.con p:first-child .el-icon-warning[data-v-5ee46b4d]{color:#ffa200}.con p[data-v-5ee46b4d]:last-child{font-size:.2rem;font-family:Roboto-Regular,Roboto;font-weight:500;color:#1f1f1f;line-height:.24rem;padding-left:.3rem}", ""]);

// exports
